<template>
    <div v-if="getApplyStatusDetail.appStatus">

        <!-- 応募状況 -->
        <app-status :item="getApplyStatusDetail.appStatus" :pj-disable="pj_see_dis" :te-disable="te_group_err"></app-status>

        <!-- Nav tabs -->
        <ul class="nav nav-tabs tab-sticky-msg breadcrumb p-0 mb-1 nav-justified" role="tablist">
            <li class="nav-item">
                <a class="nav-link text-center px-2" data-toggle="tab" href="#pjMsg">
                    案件Msg
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link active text-center px-2" data-toggle="tab" href="#teMsg">
                    要員Msg
                </a>
            </li>
        </ul>
        <div class="tab-content">
            <div id="pjMsg" class="container tab-pane fade p-0">
                <!-- 案件 -->
                <div v-if="pj_see_dis" class="card card-body text-danger">
                    <div v-if="pj_group_err">
                        登録Groupと所属Groupが異なるため、メッセージは送信できません。
                    </div>
                    <div v-if="te_info_err">
                        要員履歴書PDF・提案情報は必須です。
                    </div>
                </div>
                <app-msg v-else :msgs="getApplyStatusDetail.pjMsgs"
                    :apply-id="getApplyStatusDetail.appId" 
                    sender-type="3"></app-msg>
            </div>
            <div id="teMsg" class="container tab-pane active p-0">
                <!-- 要員 -->
                <div v-if="te_group_err" class="card card-body text-danger">登録Groupと所属Groupが異なるため、メッセージは送信できません。</div>
                <app-msg v-else :msgs="getApplyStatusDetail.teMsgs" 
                    :apply-id="getApplyStatusDetail.appId" 
                    sender-type="1"></app-msg>
            </div>
        </div>

        <!-- メッセージ -->
        <info-msg ref="infoMsg" :lev="lev" :msg="msg"></info-msg>
    </div>
</template>

<script>
    import AppMsg from 'pages/commons/apply/ApplyMsg'
    import InfoMsg from 'pages/commons/modal/infoMsg/InfoMsg'
    import AppStatus from './Status'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            AppMsg,
            AppStatus,
            InfoMsg
        },
        data () {
            return {
                lev: 0,
                msg: "",
            }
        },
        watch:{
            getAddApplyHisMsgStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    this.pushCommentToList()
                    this.$store.dispatch('doneSpinner')
                }
                if (status == 3) {
                    this.$store.dispatch('doneSpinner')
                }
            }
        },
        computed: {
            pj_see_dis () {
                return this.te_info_err || this.pj_group_err ? true : false
            },
            te_info_err () {
                if (this.getApplyStatusDetail.tech) {
                    let resume_flg = this.getApplyStatusDetail.tech.resume_pdf ? true : false
                    let te_pub_flg = this.getApplyStatusDetail.tech.tech_info_pub ? true : false
                    return resume_flg && te_pub_flg ? false : true
                } else {
                    return false
                }
            },
            te_group_err () {
                if (this.getApplyStatusDetail.tech) {
                    let input_group = this.getApplyStatusDetail.tech.input_group
                    let user_group = this.getApplyStatusDetail.tech.user_group
                    return input_group == user_group ? false : true
                } else {
                    return false
                }
            },
            pj_group_err () {
                if (this.getApplyStatusDetail.proj) {
                    let input_group = this.getApplyStatusDetail.proj.proj_user_group
                    let user_group = this.getApplyStatusDetail.proj.rec_user_group
                    return input_group == user_group ? false : true
                } else {
                    return false
                }
            },
            ...mapGetters(['getApplyStatusDetail', 'getAddApplyHisMsgStatus', 'getAddApplyHisMsg'])
        },
        methods: {
            pushCommentToList () {
                if (this.getAddApplyHisMsg.sender_type == '1') {
                    this.getApplyStatusDetail.teMsgs.push(this.getAddApplyHisMsg)
                    if (this.getApplyStatusDetail.appStatus.te_see == '0') {
                        this.openInfoMsg(1, '要員側は不可視です。')
                    }
                }
                if (this.getAddApplyHisMsg.sender_type == '3') {
                    this.getApplyStatusDetail.pjMsgs.push(this.getAddApplyHisMsg)
                    if (this.getApplyStatusDetail.appStatus.pj_see == '0') {
                        this.openInfoMsg(1, '案件側は不可視です。')
                    }
                }
            },
            openInfoMsg (lev, msg) {
                this.lev = lev
                this.msg = msg
                this.$refs.infoMsg.openThis()
            },
        }
        
    }

</script>

<style lang="stylus" scoped>
.tab-sticky-msg
    position: sticky!important;
    top: 167px!important;
    z-index: 97;
</style>
